import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { useCart } from '../../CartContext';
import { supabase } from '../../lib/supabaseClient.ts';

// Main category list with icons
const categories = [
  {
    name: "Alimentation",
    image: "img/icons/alimentation.jpg",
    subcategories: ["Croquettes", "Boîtes & Pochon & Barquette", "Friandises", "Compléments alimentaires"]
  },
  {
    name: "Hygiène et soins",
    image: "img/icons/higiene.jpeg",
    subcategories: ["Produits antiparasitaires", "Produits d'hygiène", "Matériel toilettage"]
  },
  {
    name: "Cage et Sacs de transports",
    image: "img/icons/sac.jpg",

  },
  {
    name: "Gamelles et distributeur",
    image: "img/icons/gamelle.jpg",

  },
  {
    name: "Arbre à chat et griffoirs",
    image: "img/icons/arbre.jpg",

  },
  {
    name: "Jouets",
    image: "img/icons/jouets.jpeg",

  },
  {
    name: "Litière",
    image: "img/icons/lait.jpg",

    subcategories: ["Abosorbante", "Agglomérante", "Bac et Maison de toilette"]
  },
  {
    name: "Sellerie",
    image: "img/icons/Sellerie.jpg",

    emptyMessage: "Aucun produit ne correspond à votre sélection 🐾"

  }
];
const products = [
  // Alimentation > Croquette
  { id: 1, name: "Brit Care Sans Céréales Pour chats", category: "Alimentation", subcategory: "Croquette", priceRange: "15,300DT – 148,500DT", image: "img/product/brit-care-chat.jpg",promo: true  },
  { id: 2, name: "Brit Premium By Nature", category: "Alimentation", subcategory: "Croquette", priceRange: "10,800DT – 139,500DT", image: "img/product/brit-premium.jpg",promo: true  },
  { id: 3, name: "Carnilove Chat", category: "Alimentation", subcategory: "Croquette", priceRange: "71,000DT", image: "img/product/carnilove-chat.jpeg" },
  { id: 4, name: "Carnilove TRUE FRESH", category: "Alimentation", subcategory: "Croquette", priceRange: "73,500DT", image: "img/product/carnilove-truefresh.jpg" },
  { id: 5, name: "COTAGRO CHAT DAILY MENU 20KG", category: "Alimentation", subcategory: "Croquette", priceRange: "52,000DT – 207,000DT", image: "img/product/cotagro-dailymenu.jpg" },
  { id: 6, name: "Diamant premium au Poisson pour chat stérilisé 15kg", category: "Alimentation", subcategory: "Croquette", priceRange: "169,000DT", image: "img/product/diamant-premium.jpg" },
  { id: 7, name: "Friskies Chat", category: "Alimentation", subcategory: "Croquette", priceRange: "34,000DT", image: "img/product/friskies.jpg" },
  { id: 8, name: "OWNAT CLASSIC CHAT", category: "Alimentation", subcategory: "Croquette", priceRange: "11,000DT – 250,000DT", image: "img/product/ownat-classic.jpg" },
  { id: 9, name: "Royal canin Chat", category: "Alimentation", subcategory: "Croquette", priceRange: "90,000DT – 110,000DT", image: "img/product/royalcanin-chat.jpg" },
  { id: 10, name: "Royal Canin Chat Stérilisé", category: "Alimentation", subcategory: "Croquette", priceRange: "28,000DT – 380,000DT", image: "img/product/royalcanin-steril.jpg" },
  { id: 11, name: "Royal Canin Pour Chaton", category: "Alimentation", subcategory: "Croquette", priceRange: "95,000DT – 110,000DT", image: "img/product/royalcanin-kitten.jpeg" },
  { id: 12, name: "Croquettes pour Chat Starcat Mix 15kg", category: "Alimentation", subcategory: "Croquette", priceRange: "28,000DT – 169,000DT", image: "img/product/starcat.jpg" },


  { id: 13, name: "VET BARQ. CAT DERMATOSIS 100 G", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "5,500DT", image: "img/product/vet-barq.jpg" },
  { id: 14, name: "BARQUETTE ECO DIANA", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "2,700DT", image: "img/product/eco-diana.jpg" },
  { id: 15, name: "BARQUETTE PLAISIR", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "3,000DT – 3,300DT", image: "img/product/plaisir-barquette.jpg" },
  { id: 16, name: "Boite Kippy Chat 400 GR", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "7,000DT – 7,800DT", image: "img/product/kippy-chat.jpg", promo: true },
  { id: 17, name: "PLAISIR CHEF CHAT 190G CASSEROLE DE POULET AVEC TOMATES & OLIVES", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "7,800DT", image: "img/product/plaisir-casserole.png" },
  { id: 18, name: "POCHON ECO DIANA", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "2,700DT", image: "img/product/pochon-eco-diana.png" },
  { id: 19, name: "POCHON PLAISIR", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "2,700DT – 2,970DT", image: "img/product/pochon-plaisir.png", promo: true  },
  { id: 20, name: "POCHON PLAISIR CARE", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "3,000DT", image: "img/product/pochon-plaisir-care.jpg" , promo: true },
  { id: 21, name: "Royal Canin Pochons", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "7,000DT", image: "img/product/royalcanin-pochon.jpg" },
  { id: 22, name: "PLAISIR CHEF CHAT 190G TERRINE SAUMON AVEC ÉPINARDS & CRÈME", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "7,800DT", image: "img/product/plaisir-terrine.jpg" },
  { id: 23, name: "Wanpy Crème – Saveurs Mixtes 25x14g", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "39,000DT", image: "img/product/wanpy-creme.jpg" },
  { id: 24, name: "Wanpy Délicieuse Purée – Poulet et Carottes 90g", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "9,000DT", image: "img/product/wanpy-poulet-carottes.jpg" },
  { id: 25, name: "Wanpy Délicieuse Purée – Saumon, Poulet et Carottes 90g", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "9,000DT", image: "img/product/wanpy-saumon.jpg" },
  {
    id: 26,
    name: "Canvit Antistress pour Chien et Chat 230g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "74,000DT",
    image: "img/product/canvit-antistress.jpg"
  },
  {
    id: 27,
    name: "Canvit Biotine pour Chat 100g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "32,000DT",
    image: "img/product/canvit-biotin.jpeg"
  },
  {
    id: 28,
    name: "Canvit Chondro pour Chat 100g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "42,000DT",
    image: "img/product/canvit-chondro.png"
  },
  {
    id: 29,
    name: "Canvit Garlic pour Chien et Chat 230g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "79,000DT",
    image: "img/product/canvit-garlic.jpg"
  },
  {
    id: 30,
    name: "Canvit Immuno Booster pour Chat 30g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "78,000DT",
    image: "img/product/canvit-immuno.png"
  },
  {
    id: 31,
    name: "Canvit Nutrimin pour Chat 150g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "35,000DT",
    image: "img/product/canvit-nutrimin.jpeg"
  },
  {
    id: 32,
    name: "Lait pour Chaton Brit Care 250g",
    category: "Alimentation",
    subcategory: "Compléments alimentaires",
    priceRange: "64,000DT",
    image: "img/product/lait-chaton-britcare.png"
  },
  { id: 33, name: "Herball Balle de Matatbi Adhésive", category: "Alimentation", subcategory: "Friandises", priceRange: "9,000DT", image: "img/product/herball-matatabi.jpeg" },
  { id: 34, name: "Jerky Time Sushi Poulet et Cabillaud 80g", category: "Alimentation", subcategory: "Friandises", priceRange: "12,000DT", image: "img/product/jerky-sushi.jpeg" },
  { id: 35, name: "Truly Stick au Thon avec Taurine 50g", category: "Alimentation", subcategory: "Friandises", priceRange: "8,000DT", image: "img/product/truly-stick.jpg" },
  { id: 36, name: "Wanpy Crème – Poulet 25x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "39,000DT", image: "img/product/wanpy-creme-poulet-25.jpg" },
  { id: 37, name: "Wanpy Crème – Poulet 5x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "9,000DT", image: "img/product/wanpy-creme-poulet-25.jpg" },
  { id: 38, name: "Wanpy Crème – Saveurs Mixtes 25x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "39,000DT", image: "img/product/wanpy-mix-25.png" },
  { id: 39, name: "Wanpy Crème – Thon et Saumon 5x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "9,000DT", image: "img/product/wanpy-thon-saumon.jpg" },
  { id: 40, name: "Wanpy Crème – Thon, Poulet et Crabe 5x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "9,000DT", image: "img/product/wanpy-thon-poulet-crabe.jpeg" },
  { id: 41, name: "Wanpy Crème Functionnal – Hairball Control au Cabillaud et Poulet 5x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "10,000DT", image: "img/product/wanpy-hairball.jpeg" },
  { id: 42, name: "Wanpy Crème Functionnal – Skin & Coat au Thon et Saumon 5x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "10,000DT", image: "img/product/wanpy-skin-coat.jpg" },
  { id: 43, name: "Wanpy Crème Functionnal – Urinary au Canard et Poulet 5x14g", category: "Alimentation", subcategory: "Friandises", priceRange: "10,000DT", image: "img/product/wanpy-urinary.jpg" },
  { id: 44, name: "Wanpy Délicieuse Purée – Poulet et Carottes 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "9,000DT", image: "img/product/wanpy-poulet-carottes.png" },
  { id: 45, name: "Wanpy Délicieuse Purée – Saumon, Poulet et Carottes 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "9,000DT", image: "img/product/wanpy-saumon-poulet-carottes.jpg" },

  {
    id: 46,
    name: "CAT OTOY PETS A FEEGG-CERSIZER",
    category: "Gamelles et distributeur",
    priceRange: "48,000DT",
    image: "img/product/otoy-pets.jpg"
  },
  {
    id: 47,
    name: "Distributeur Eau et Croquettes Snail Combi",
    category: "Gamelles et distributeur",
    priceRange: "22,000DT – 99,000DT",
    image: "img/product/snail-combi.jpg"
  },
  {
    id: 48,
    name: "Doseur électronique",
    category: "Gamelles et distributeur",
    priceRange: "59,000DT",
    image: "img/product/doseur-electronique.jpg"
  },
  {
    id: 49,
    name: "Fontaine à Eau Taupe 220 V",
    category: "Gamelles et distributeur",
    priceRange: "119,000DT",
    image: "img/product/fontaine-eau.jpeg"
  },
  {
    id: 50,
    name: "Gamelle de voyage en silicone 1000 ML",
    category: "Gamelles et distributeur",
    priceRange: "19,000DT",
    image: "img/product/gamelle-voyage-1000ml.png"
  },
  {
    id: 51,
    name: "Gamelle de voyage en silicone 500 ML",
    category: "Gamelles et distributeur",
    priceRange: "15,000DT",
    image: "img/product/gamelle-voyage-500ml.png"
  },
  {
    id: 52,
    name: "TAPIS DE GRATTAGE AVEC CATNIP 48 CM",
    category: "Arbre à chat et griffoirs",
    priceRange: "27,000DT",
    image: "img/product/grattage-catnip-48cm.jpg"
  },
  {
    id: 53,
    name: "TAPIS DE GRATTAGE ESSENCE NOCE",
    category: "Arbre à chat et griffoirs",
    priceRange: "19,000DT",
    image: "img/product/grattage-noce.jpg"
  },
  {
    id: 54,
    name: "TAPIS DE GRATTAGE ESSENCE WENGE",
    category: "Arbre à chat et griffoirs",
    priceRange: "19,000DT",
    image: "img/product/grattage-wenge.jpg"
  },
  {
    id: 55,
    name: "TAPIS DE GRATTAGE TEXTURE LEAVES",
    category: "Arbre à chat et griffoirs",
    priceRange: "19,000DT",
    image: "img/product/grattage-leaves.jpg"
  },
  {
    id: 56,
    name: "TAPIS DE GRATTAGE TEXTURE MAIOLICA",
    category: "Arbre à chat et griffoirs",
    priceRange: "19,000DT",
    image: "img/product/grattage-maiolica.jpg"
  },
  {
    id: 57,
    name: "TAPIS DE GRATTAGE WAVY CM.50 AVEC CATNIP",
    category: "Arbre à chat et griffoirs",
    priceRange: "29,000DT",
    image: "img/product/grattage-wavy-catnip.jpg"
  },
  {
    id: 58,
    name: "Brosses à dents doubles",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "16,000DT",
    image: "img/product/brosse-dents-doubles.jpeg"
  },
  {
    id: 59,
    name: "Ciseaux de Toilettage à Effiler",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "37,000DT",
    image: "img/product/ciseaux-effiler.jpg"
  },
  {
    id: 60,
    name: "Ciseaux de Toilettage Courbés",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "39,000DT",
    image: "img/product/ciseaux-courbes.jpeg"
  },
  {
    id: 61,
    name: "Ciseaux de Toilettage Droits",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "37,000DT",
    image: "img/product/ciseaux-droits.jpeg"
  },
  {
    id: 62,
    name: "Coupe Griffes Petit Modèle",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "15,000DT",
    image: "img/product/coupe-griffes.jpg"
  },
  {
    id: 63,
    name: "Peigne anti-puces 5X7CM",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "9,000DT",
    image: "img/product/peigne-anti-puces.jpg"
  },
  {
    id: 64,
    name: "Serviette ultra absorbante en microfibres L",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "54,000DT",
    image: "img/product/serviette-l.jpg"
  },
  {
    id: 65,
    name: "Serviette ultra absorbante en microfibres M",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "34,000DT",
    image: "img/product/serviette-m.jpeg"
  },
  {
    id: 66,
    name: "Tondeuse pour finitions (pattes, face, queue) sans fil",
    category: "Hygiène et soins",
    hygieneSubcategories: "Matériel toilettage",
    priceRange: "79,000DT",
    image: "img/product/tondeuse-sans-fil.jpg"
  },
  {
    id: 67,
    name: "Shampoing",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits antiparasitaires",
    priceRange: "20,000DT – 39,000DT",
    image: "img/product/shampoing.jpg"
  },
  {
    id: 68,
    name: "test",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits antiparasitaires",
    priceRange: "80,000DT – 100,000DT",
    image: "img/product/test.jpg"
  },
  {
    id: 69,
    name: "2 Rouleaux Adhésifs 100 Feuilles",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "18,000DT",
    image: "img/product/rouleaux-100.jpg"
  },
  {
    id: 70,
    name: "2 Rouleaux Adhésifs 60 Feuilles",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "14,000DT",
    image: "img/product/rouleaux-60.jpg"
  },
  {
    id: 71,
    name: "Brosses à dents doubles",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "16,000DT",
    image: "img/product/brosse-dents-double.jpg"
  },
  {
    id: 72,
    name: "GILL’S OTO CLEAN 50ml",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "22,000DT",
    image: "img/product/oto-clean.jpg"
  },
  {
    id: 73,
    name: "Lingettes",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "12,000DT – 19,900DT",
    image: "img/product/lingettes.jpg"
  },
  {
    id: 74,
    name: "Nettoyant",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "22,000DT – 32,000DT",
    image: "img/product/nettoyant.jpeg"
  },
  {
    id: 75,
    name: "Set de brosses à dents",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "12,000DT",
    image: "img/product/set-brosses.jpeg"
  },
  {
    id: 76,
    name: "Shampoing",
    category: "Hygiène et soins",
    hygieneSubcategories: "Produits d'hygiène",
    priceRange: "20,000DT – 39,000DT",
    image: "img/product/shampoing.jpg"
  },
  {
    id: 77,
    name: "Balle rigolotte en tissu coloré",
    category: "Jouets",
    priceRange: "12,000DT",
    image: "img/product/balle-rigolotte.jpg"
  },
  {
    id: 78,
    name: "Canne à pêche avec Matatabi et Catnip",
    category: "Jouets",
    priceRange: "12,000DT",
    image: "img/product/canne-matatabi.jpeg"
  },
  {
    id: 79,
    name: "Canne avec souris en tissu coloré",
    category: "Jouets",
    priceRange: "12,000DT",
    image: "img/product/canne-souri.png"
  },
  {
    id: 80,
    name: "Caramelle Sisal avec plumes",
    category: "Jouets",
    priceRange: "9,000DT",
    image: "img/product/caramelle-sisal.jpg"
  },
  {
    id: 81,
    name: "CAT OTOY PETS A FEEGG-CERSIZER",
    category: "Jouets",
    priceRange: "48,000DT",
    image: "img/product/otoy-feegg.jpeg"
  },
  {
    id: 82,
    name: "CAT TOY BAKERY CUPCAKE PINK CATNIP 7cm",
    category: "Jouets",
    priceRange: "13,500DT",
    image: "img/product/cupcake-catnip.png"
  },
  {
    id: 83,
    name: "JOUET CHAT AVEC CATNIP",
    category: "Jouets",
    priceRange: "5,900DT",
    image: "img/product/jouet-catnip.jpeg"
  },
  {
    id: 84,
    name: "JOUET CHAT STICK WITH BEAR MIXED SUBJECT",
    category: "Jouets",
    priceRange: "14,000DT",
    image: "img/product/stick-bear.jpg"
  },
  {
    id: 85,
    name: "JOUET CHAT VENTOUSE PETCRAFT",
    category: "Jouets",
    priceRange: "17,000DT",
    image: "img/product/jouet-ventouse.jpg"
  },
  {
    id: 86,
    name: "Jouet pour Chaton Swirl 22cm",
    category: "Jouets",
    priceRange: "49,000DT",
    image: "img/product/swirl-chaton.jpg"
  },
  {
    id: 87,
    name: "POINTEUR LASER LED MIX",
    category: "Jouets",
    priceRange: "7,000DT",
    image: "img/product/laser-led.jpg"
  },
  {
    id: 88,
    name: "Souris à piles Otto",
    category: "Jouets",
    priceRange: "13,000DT",
    image: "img/product/souris-otto.jpg"
  },
  {
    id: 89,
    name: "Souris Catnip avec queue en Plumes",
    category: "Jouets",
    priceRange: "7,000DT",
    image: "img/product/souris-catnip.jpg"
  },
  {
    id: 90,
    name: "Souris en tissu et plumes avec herbe à chat",
    category: "Jouets",
    priceRange: "12,000DT",
    image: "img/product/souris-tissu.jpg"
  },
  {
    id: 91,
    name: "TOY IN CAN SOCKY10,5cm",
    category: "Jouets",
    priceRange: "9,000DT",
    image: "img/product/socky-can.jpg"
  },
  {
    id: 92,
    name: "Tunnel pour Chat Linz 50*25cm",
    category: "Jouets",
    priceRange: "35,000DT",
    image: "img/product/tunnel-linz-50.jpeg"
  },
  {
    id: 93,
    name: "Tunnel pour Chat Linz 90*25cm",
    category: "Jouets",
    priceRange: "49,000DT",
    image: "img/product/tunnel-linz-90.jpg"
  },
  {
    id: 94,
    name: "BioKitty Litière Agglomérante 10L",
    category: "Litière",
    subcategory: "Agglomérante",
    priceRange: "25,000DT",
    image: "img/product/biokitty-10l.jpeg"
  },
  {
    id: 95,
    name: "BioKitty Litière Agglomérante 20L",
    category: "Litière",
    subcategory: "Agglomérante",
    priceRange: "40,000DT – 42,000DT",
    image: "img/product/biokitty-20l.jpg"
  },
  {
    id: 96,
    name: "Lindocat Advanced Control+ 6L",
    category: "Litière",
    subcategory: "Agglomérante",
    priceRange: "23,000DT",
    image: "img/product/lindocat.jpg"
  },
  {
    id: 97,
    name: "Litière LindoCat",
    category: "Litière",
    subcategory: "Agglomérante",
    priceRange: "11,200DT – 27,200DT",
    image: "img/product/lindocat-6l.jpg",
     promo: true 
  },
  {
    id: 98,
    name: "BAC A LITIERE CHATON 38CM",
    category: "Litière",
    subcategory: "Bac et Maison de toilette",
    priceRange: "14,000DT",
    image: "img/product/bac-litiere-chaton.jpeg"
  },
  {
    id: 99,
    name: "PELLE HYGIENIC BULL BUSTER",
    category: "Litière",
    subcategory: "Bac et Maison de toilette",
    priceRange: "8,000DT",
    image: "img/product/pelle-bull-buster.jpg"
  },
  {
    id: 100,
    name: "Cage de Transport Pour Chat et Chien Avec Roues Kim 60",
    category: "Cage et Sacs de transports",
    priceRange: "119,000DT",
    image: "img/product/cage-transport-kim60.jpg"
  },
  {
    id: 101,
    name: "Panier de Transport Black Diamond 50*27*26cm",
    category: "Cage et Sacs de transports",
    priceRange: "175,000DT",
    image: "img/product/panier-black-diamond.jpeg"
  },
  {
    id: 102,
    name: "Panier de Transport Premium Marron 50*27*26cm",
    category: "Cage et Sacs de transports",
    priceRange: "229,000DT",
    image: "img/product/panier-premium-marron.png"
  },
  {
    id: 103,
    name: "Sac de Transport Blue Rose 30*40*24",
    category: "Cage et Sacs de transports",
    priceRange: "119,000DT",
    image: "img/product/sac-transport-blue-rose.jpg"
  },
  {
    id: 104,
    name: "Sac de Transport Leona 44x24x29 cm",
    category: "Cage et Sacs de transports",
    priceRange: "159,000DT",
    image: "img/product/sac-transport-leona.jpg"
  },
  {
    id: 105,
    name: "Sac de Transport Mamut 30*40*24cm",
    category: "Cage et Sacs de transports",
    priceRange: "125,000DT",
    image: "img/product/sac-transport-mamut.jpg"
  },
  {
    id: 106,
    name: "Sac de Transport Standard Collection 30*40*24cm",
    category: "Cage et Sacs de transports",
    priceRange: "65,000DT",
    image: "img/product/sac-transport-standard.jpg"
  }



];
// Subcategories for Alimentation
const subcategories = [
  "Croquette",
  "Boîtes & Pochon & Barquette",
  "Friandises",
  "Compléments alimentaires",

];
const hygieneSubcategories = [
  "Produits d'hygiène",
  "Produits antiparasitaires",
  "Matériel toilettage"
];
const brands = [
  "STEFANPLAST",
  "CROCI",
];



function ShopAreaRongeur() {
  const [categories, setCategories] = useState([]);
   const [products, setProducts] = useState([]);
   const [selectedCategory, setSelectedCategory] = useState("");
   const [selectedSubcategory, setSelectedSubcategory] = useState("");
 const navigate = useNavigate();

   // Fetch categories and products for 'cat'
   useEffect(() => {
     const fetchCategories = async () => {
       const { data, error } = await supabase
         .from("categories")
         .select("*")
         .eq("pet_type", "rongeur")
         .order("order", { ascending: true })

 
       if (error) {
         console.error("Error fetching categories:", error);
       } else {
         setCategories(data);
         if (data.length > 0) {
           setSelectedCategory(data[0].name); // Default category
         }
       }
     };
 
     const fetchProducts = async () => {
 const { data, error } = await supabase
   .from("products")
   .select("id, name, image, price_range, description, category, subcategory");
 
       if (error) {
         console.error("Error fetching products:", error);
       } else {
         setProducts(data);
       }
     };
 
     fetchCategories();
     fetchProducts();
   }, []);
 
   const selectedCategoryObj = categories.find((cat) => cat.name === selectedCategory);
   const subcategories = selectedCategoryObj?.subcategories || [];
 
   const filteredProducts = products.filter((product) => {
     const matchCategory = product.category === selectedCategory;
     const matchSubcategory = selectedSubcategory
       ? product.subcategory === selectedSubcategory
       : true;
     return matchCategory && matchSubcategory;
   });
 

  return (
    <div className="shop-area pt-110 pb-110">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="shop-wrap">
              <h4 className="title mb-4">Categories</h4>

              {/* Category Cards */}
              <div className="row mb-4">
                {categories.map(cat => {
                  const productCount = products.filter(p => p.category === cat.name).length;
                  const isSelected = selectedCategory === cat.name;

                  return (
                    <div key={cat.name} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                      <button
                   onClick={() => {
      navigate(`/category/${cat.id}/${encodeURIComponent(cat.name)}`);
}}

                        style={{
                                   width: "100%",
                          height: "230px",
                          backgroundColor: isSelected ? "#fff" : "#fff",
                          color: isSelected ? "#333" : "#333",
                          border: isSelected ? "2px solid #000" : "1px solid #ddd",
                          borderRadius: "12px",
                          overflow: "hidden",
                          padding: 0,
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                          boxShadow: isSelected ? "0 4px 10px rgba(0,0,0,0.2)" : "0 2px 6px rgba(0,0,0,0.06)",
                        }}
                      >
                        <div style={{ height: "100px", overflow: "hidden" }}>
                                           <img
  src={cat.image}
  alt={cat.name}
  style={{
    width: "40%",
    height: "90%",
    objectFit: "cover",
    marginLeft: window.innerWidth <= 768 ? "200px" : "0px", // shift on mobile
  }}
/>
                        </div>
                        <div style={{ padding: "8px" }}>
                          {cat.name}
                          <div style={{ fontSize: "13px", fontWeight: "normal" }}>
                            {productCount} produit{productCount > 1 ? "s" : ""}
                          </div>
                        </div>
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* Subcategory Filter */}
              {subcategories.length > 0 && (
                <div
                  className="subcategory-filter d-flex flex-wrap gap-3 mb-4"
                  style={{ justifyContent: "flex-start" }}
                >
                  {subcategories.map((sub) => (
                    <button
                      key={sub}
                      onClick={() => setSelectedSubcategory(sub)}
                      style={{
                        borderRadius: "16px",
                        padding: "10px 20px",
                        fontSize: "15px",
                        fontWeight: "500",
                        border: selectedSubcategory === sub ? "2px solid #c71585" : "1px solid #ccc",
                        backgroundColor: selectedSubcategory === sub ? "#fce5ef" : "#f9f9f9",
                        color: selectedSubcategory === sub ? "#c71585" : "#333",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        marginRight: "12px",     // <-- added spacing
                        marginBottom: "12px",    // <-- spacing between rows
                      }}
                    >
                      {sub}
                    </button>
                  ))}
                  <button
                    onClick={() => setSelectedSubcategory("")}
                    style={{
                      borderRadius: "16px",
                      padding: "10px 20px",
                      fontSize: "15px",
                      fontWeight: "500",
                      border: selectedSubcategory === "" ? "2px solid #c71585" : "1px solid #ccc",
                      backgroundColor: selectedSubcategory === "" ? "#fce5ef" : "#f9f9f9",
                      color: selectedSubcategory === "" ? "#c71585" : "#333",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      marginRight: "12px",     // <-- added spacing
                      marginBottom: "12px",
                    }}

                  >
                    Tous
                  </button>
                </div>
              )}


              {/* Product Count */}
              <div className="shop-page-meta mb-30">
                <div className="shop-showing-result">
                  <p>Total Produits {filteredProducts.length}</p>
                </div>
              </div>

              {/* Products Grid */}
              <div className="row justify-content-center">
                {filteredProducts.length > 0 ? (
                  filteredProducts.slice(0, 20).map(product => (
                    <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                      <div
                        className="shop-item"
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                          padding: "16px",
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className="shop-thumb"
                          style={{
                            height: "220px",
                            overflow: "hidden",
                            borderRadius: "8px",
                            marginBottom: "1rem",
                          }}
                        >
                         {product.promo && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "10px",
                                                                right: "10px",
                                                                backgroundColor: "green",
                                                                color: "#fff",
                                                                padding: "4px 8px",
                                                                borderRadius: "12px",
                                                                fontSize: "12px",
                                                                fontWeight: "600",
                                                                zIndex: 10
                                                            }}
                                                        >
                                                            Promo
                                                        </div>
                                                    )}

                          <Link to={`/shop-details/${product.id}`}>
                            <img
                              src={product.image}
                              alt={product.name}
                              style={{
                                width: "50%",
                                height: "90%",
                                objectFit: "cover",
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto",
                              }}
                            />
                          </Link>
                        </div>
                        <div className="shop-content">
                          <h5
                            style={{
                              fontSize: "16px",
                              fontWeight: "600",
                              marginBottom: "8px",
                            }}
                          >
                            <Link to={`/shop-details/${product.id}`} style={{ color: "#333", textDecoration: "none" }}>
                              {product.name}
                            </Link>
                          </h5>
                          <div
                            className="shop-content-bottom"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span className="price" style={{ fontWeight: "bold", color: "#c71585" }}>
                              {product.priceRange}
                            </span>
                            <span className="add-cart">

                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center mt-4">
                    <p className="fs-5">
                      🐾 {
                        categories.find(c => c.name === selectedCategory)?.emptyMessage
                        || "Aucun produit trouvé."
                      }
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default ShopAreaRongeur;
